module.exports = __webpack_public_path__ + "112edbe4ea550f132e00e357af2e6be5.png";